<template>
  <ul class="pagination justify-content-center">
    <li :class="paginationClass(n)" v-for="n in totalPage" :key="n" >
      <router-link class="page-link" :to="`${url}/${n}`">{{n}}</router-link>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    page: {
      required: true
    },
    itemCount: {
      required: true
    },
    perPage: {
      type: Number,
      default: parseInt(process.env.VUE_APP_ENV_PER_PAGE)
    }
  },
  data () {
    return {
      totalPage: 0,
      url: ''
    }
  },
  created () {
    this.init()
  },
  computed: {
    findTotalPage () {
      const total = Math.ceil(this.itemCount / this.perPage)
      return total
    }
  },
  methods: {
    paginationClass (n) {
      let _class = 'page-item'
      if (this.page === n.toString()) {
        _class += ' active'
      }
      return _class
    },
    init () {
      const _url = this.$router.currentRoute.value.matched[0].path.replace('/:page', '').replace(':id', this.$route.params.id).replace(':ne', this.$route.params.ne).trim()
      this.totalPage = this.findTotalPage
      this.url = _url
    }
  },
  watch: {
    itemCount: function (val) {
      this.totalPage = this.findTotalPage
    },
    $route: function () {
      this.init()
    }
  }
}
</script>

<style scoped>
</style>
